export default __webpack_public_path__ + "static/media/032-milkshake.5c26dbee.svg";